import { motion, useInView } from "framer-motion"
import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const PromotionsListing = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade2 = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.75,
        staggerChildren: 0.4,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  const promdata = useStaticQuery(graphql/* GraphQL */ `
    query PromotionQuery {
      allWpPromotionCategory(sort: { id: ASC }) {
        nodes {
          name
          slug
        }
      }
      allWpPromotion(
        sort: { date: DESC }
        filter: { id: { ne: "cG9zdDo4MTQ=" } }
      ) {
        nodes {
          uri
          id
          title
          excerpt
          date
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          promotionContent {
            weekdayTime
            validUntill
            selectSite
            pricePerPerson
            bookNow {
              target
              title
              url
            }
          }
          promotionCategory {
            nodes {
              slug
              name
            }
          }
        }
      }
    }
  `)

  const categories = promdata.allWpPromotionCategory.nodes
  const allpromData = promdata.allWpPromotion.nodes

  const exFixLimit = 100
  const [experinceLimit, setExLimit] = useState(exFixLimit)
  const [cExLimit, setCexLimit] = useState(exFixLimit)
  const [tabDetails, setTabDetails] = useState(allpromData.slice(0, exFixLimit))
  const [tabOption, setTabOption] = useState("all")

  useEffect(() => {
    if (tabOption !== "all") {
      const arrayData = []
      for (var i = 0; i < allpromData.length; i++) {
        for (
          var j = 0;
          j < allpromData[i].promotionCategory.nodes.length;
          j++
        ) {
          if (allpromData[i].promotionCategory.nodes[j].name === tabOption) {
            arrayData.push(allpromData[i])
          }
        }
      }
      setCexLimit(arrayData.length)
      setTabDetails(arrayData.slice(0, experinceLimit))
    } else {
      setCexLimit(allpromData.length)
      setTabDetails(allpromData.slice(0, experinceLimit))
    }
  }, [tabOption, experinceLimit, allpromData])

  const handleSelectChange = event => {
    setExLimit(exFixLimit)
    setTabOption(event.target.value)
  }

  if (module.hideSection === "no") {
    const featureData = module.selectFeaturePromotion
    return (
      <>
        {module?.selectFeaturePromotion && (
          <motion.section
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="img-with-content pb-50 pt-50"
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="container-fluid"
            >
              <div className="border-1 border-charcoal rounded-2 py-50 px-80 xlscreen:px-40 lgscreen:px-20 lgscreen:py-20">
                <div className="flex flex-wrap items-center">
                  <div className="lg:w-6/12 w-full">
                    {featureData?.featuredImage && (
                      <motion.div variants={animFade} className="img relative">
                        <ImageOpt
                          imgData={featureData.featuredImage.node.mediaItemUrl}
                          width={2184}
                          height={1467}
                          imgAlt={featureData.featuredImage.node.altText}
                          imgLoad="lazy"
                        />
                      </motion.div>
                    )}
                  </div>
                  <div className="lg:w-6/12 w-full">
                    <div className="img-with-content-inner pl-80 xlscreen:pl-40 lgscreen:pl-0 lgscreen:pt-30">
                      {featureData?.promotionContent?.selectSite && (
                        <motion.div
                          variants={animFade}
                          className="preheading mb-15 lgscreen:mb-15"
                        >
                          <span className="font-ositalic text-16 text-charcoal">
                            {featureData.promotionContent.selectSite}
                          </span>
                        </motion.div>
                      )}
                      <motion.h3 variants={animFade}>
                        {featureData.title}
                      </motion.h3>
                     
                     <div className="flex flex-col items-start gap-y-[5px]">
                        {featureData?.promotionContent?.weekdayTime && (
                          <motion.div
                            variants={animFade}
                            className="flex items-center gap-x-[5px]"
                          >
                            <img
                              src="../images/history.svg"
                              className="relative -top-2"
                              width={12}
                              height={12}
                              loading="lazy"
                              alt="History"
                            />
                            <span className="font-ositalic text-13">
                              {featureData.promotionContent.weekdayTime}
                            </span>
                          </motion.div>
                        )}
                        {featureData?.promotionContent?.validUntill && (
                          <motion.div
                            variants={animFade}
                            className="flex items-center gap-x-[5px] pt-10"
                          >
                            <img
                              src="../images/event.svg"
                              className="relative -top-2"
                              width={12}
                              height={12}
                              loading="lazy"
                              alt="Event"
                            />
                            <span className="font-ositalic text-13">
                              {featureData.promotionContent.validUntill}
                            </span>
                          </motion.div>
                        )}
                        {featureData?.promotionContent?.pricePerPerson && (
                          <motion.div
                            variants={animFade}
                            className="flex items-center gap-x-[5px]"
                          >
                            <img
                              src="../../images/credit-card.svg"
                              className="relative"
                              width={12}
                              height={12}
                              loading="lazy"
                              alt="Credit Card"
                            />
                            <span className="font-ositalic text-13">
                              {featureData.promotionContent.pricePerPerson}
                            </span>
                          </motion.div>
                        )}

                        <motion.div
                          variants={animFade}
                          className="content pt-15"
                        >
                          {parse(featureData.excerpt)}
                        </motion.div>
                        <div className="flex flex-row items-start gap-x-4 mt-30">
                          {featureData?.promotionContent?.bookNow && (
                            <motion.div variants={animFade}>
                              <Link
                                to={featureData.promotionContent.bookNow.url}
                                className="btn btn-black"
                                target={featureData.promotionContent.bookNow.target}
                              >
                                {featureData.promotionContent.bookNow.title}
                              </Link>
                            </motion.div>
                          )}
                          <motion.div variants={animFade}>
                            <Link
                              to={featureData.uri}
                              className="btn btn-border"
                            >
                              explore
                            </Link>
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.section>
        )}

        <section
          className={`bg-white-100 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className={`filter-listing pt-50 pb-80 lgscreen:pb-30${
              module.extraClass ? ` ${module.extraClass}` : ""
            }`}
            id={module.extraId}
          >
            <motion.div
              ref={ref}
              initial="hidden"
              animate={isInView || hasPlayed ? "show" : "hidden"}
              variants={sectionShow}
              className="container-fluid"
            >
              <motion.div variants={animFade} className="text-center mt-30">
                <h2>{module.heading}</h2>
              </motion.div>
              <motion.div
                variants={animFade}
                className="content p-15 text-center"
              >
                <p>{module.description}</p>
              </motion.div>
              <motion.div
                variants={animFade}
                className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 pt-15 pb-20"
              >
                <span className="font-ositalic text-18 text-charcoal">
                  Filter By:
                </span>
                <select
                  className="border-1 border-charcoal rounded-2 w-[350px] py-[11px] px-15 outline-none"
                  onChange={handleSelectChange}
                  value={tabOption}
                >
                  <option className="whats-on-filter-parent-option" value="all">
                    All properties...
                  </option>
                  {categories
                    .filter(
                      cat =>
                        cat.slug !== "winter-speciality" &&
                        cat.slug !== "summer-speciality" &&
                        cat.slug !== "margarita-week"
                    )
                    .map((item, i) => (
                      <option key={i} value={item.name} className="pl-10">
                        {item.name}
                      </option>
                    ))}
                  <option
                    className="whats-on-filter-parent-option"
                    disabled="disabled"
                  >
                    SEASONALITY
                  </option>
                  {categories
                    .filter(
                      cat =>
                        cat.slug === "winter-speciality" ||
                        cat.slug === "summer-speciality"
                    )
                    .map((item, i) => (
                      <option key={i} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  <option
                    className="whats-on-filter-parent-option"
                    disabled="disabled"
                  >
                    THIS MONTH
                  </option>
                  {categories
                    .filter(cat => cat.slug === "margarita-week")
                    .map((item, i) => (
                      <option key={i} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </motion.div>
              <div className="flex flex-wrap mt-50 lgscreen:mt-30 -mx-20 lgscreen:mx-0 gap-y-[120px] lgscreen:gap-y-[50px] mdscreen:gap-y-[25px]">
                {tabDetails.length > 0 &&
                  tabDetails
                    .filter(
                      promo =>
                        promo.title !== module?.selectFeaturePromotion.title
                    )
                    .map((item, i) => {
                      return (
                        <div
                          className="lg:w-4/12 w-full px-20 lgscreen:px-0"
                          key={i}
                        >
                          <motion.div
                            variants={animFade2}
                            className="category-bx"
                          >
                            {item?.featuredImage && (
                              <Link to={item.uri}>
                                <div className="img relative">
                                  <ImageOpt
                                    imgData={
                                      item.featuredImage.node.mediaItemUrl
                                    }
                                    width={900}
                                    height={600}
                                    imgAlt={item.featuredImage.node.altText}
                                    imgLoad="lazy"
                                  />
                                </div>
                              </Link>
                            )}
                            <div className="category-content pt-25 pr-20 smscreen:pr-0">
                              <div className="preheading mb-5 lgscreen:mb-15">
                                <span className="font-ositalic text-16 text-charcoal">
                                  {item?.promotionCategory.nodes.length > 0 &&
                                    item?.promotionCategory.nodes.map(
                                      (itemcat, k) => {
                                        return (
                                          <span
                                            className="font-ositalic text-16 text-charcoal"
                                            key={k}
                                          >
                                            {itemcat.name}
                                            {k <
                                              item.promotionCategory.nodes
                                                .length -
                                                1 && ","}{" "}
                                            {/* Add comma if not the last element */}
                                          </span>
                                        )
                                      }
                                    )}
                                </span>
                              </div>
                              {item?.title && (
                                <h4 className="w-full max-w-[360px] xlscreen:max-w-[500px]">
                                  {item.title}
                                </h4>
                              )}
                              <div className="flex flex-wrap gap-x-3 py-10">
                                {item?.promotionContent?.weekdayTime && (
                                  <div className="flex flex-wrap items-center gap-x-[5px]">
                                    <img
                                      src="../images/history.svg"
                                      className="relative -top-1"
                                      width={12}
                                      height={12}
                                      loading="lazy"
                                      alt="Clock"
                                    />
                                    <span className="font-ositalic text-13">
                                      {item.promotionContent.weekdayTime}
                                    </span>
                                  </div>
                                )}
                                {item?.promotionContent?.validUntill && (
                                  <div className="flex flex-wrap items-center gap-x-[5px]">
                                    <img
                                      src="../images/event.svg"
                                      className="relative -top-1"
                                      width={12}
                                      height={12}
                                      loading="lazy"
                                      alt="Date"
                                    />
                                    <span className="font-ositalic text-13">
                                      {item.promotionContent.validUntill}
                                    </span>
                                  </div>
                                )}
                                {item?.promotionContent?.pricePerPerson && (
                                  <div className="flex flex-wrap items-center gap-x-[5px]">
                                    <img
                                      src="../../images/credit-card.svg"
                                      className="relative"
                                      width={12}
                                      height={12}
                                      loading="lazy"
                                      alt="Credit Card"
                                    />
                                    <span className="font-ositalic text-13">
                                      {item.promotionContent.pricePerPerson}
                                    </span>
                                  </div>
                                )}
                              </div>
                              {item?.excerpt && (
                                <div className="content w-full pr-30">
                                  {parse(item.excerpt)}
                                </div>
                              )}
                              <div className="flex flex-wrap gap-x-2 mt-25 gap-y-2">
                                {item?.promotionContent?.bookNow && (
                                  <Link
                                    to={item.promotionContent.bookNow.url}
                                    className="btn btn-black"
                                    target={
                                      item.promotionContent.bookNow.target
                                    }
                                  >
                                    {item.promotionContent.bookNow.title}
                                  </Link>
                                )}
                                <Link to={item.uri} className="btn btn-border">
                                  explore
                                </Link>
                              </div>
                            </div>
                          </motion.div>
                        </div>
                      )
                    })}
              </div>
              {/* <motion.div
                variants={animFade}
                className="flex flex-wrap justify-center mt-75 lgscreen:mt-35"
              >
                {experinceLimit < allpromData.length &&
                  cExLimit !== tabDetails.length &&
                  tabDetails.length > 0 && (
                    <button
                      className="btn btn-border opacity-50"
                      onClick={() => {
                        setExLimit(
                          experinceLimit => experinceLimit + exFixLimit
                        )
                      }}
                    >
                      Load more
                    </button>
                  )}
              </motion.div> */}

              {tabDetails.length === 0 && (
                <div className="flex flex-wrap justify-center mt-75 lgscreen:mt-35">
                  <div className="content">
                    No results found, please filter through our promotions
                    again.
                  </div>
                </div>
              )}
            </motion.div>
          </motion.div>
        </section>
      </>
    )
  }
  return null
}

export default PromotionsListing
export const PagePromotionsListingFragment = graphql`
  fragment PagePromotionsListingFragment on WpPage_Pagecontent_PageContent_PromotionsListing {
    extraId
    extraClass
    hideSection
    heading
    description
    selectFeaturePromotion {
      ... on WpPromotion {
        id
        guid
        title
        uri
        slug
        excerpt
        featuredImage {
          node {
            altText
            mediaItemUrl
          }
        }
        promotionContent {
          fieldGroupName
          selectSite
          validUntill
          weekdayTime
          pricePerPerson
          bookNow {
            target
            title
            url
          }
        }
      }
    }
  }
`
